<div class="popup-header"> {{data.refrence}} - {{data.status}}</div>

<div mat-dialog-content>

<app-table-standard-layout [dataSource$]="combObs$" [title]="'Filling reports'" [rowActionButtons]="rowActionButtons"
[columnSettings]="columnSettings" [sortingArray]='sortArray'></app-table-standard-layout>
  <!-- <table class="table">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Product Name</th>
        <th scope="col">P Number </th>
        <th scope="col">Required </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let stock of data.data;  let i = index" >
        <th scope="row">{{i+1}}</th>
        <td> {{stock.productName}}</td>
        <td>{{stock.productNumber}}</td>
        <td scope="row" >{{stock.requiredQuantity}}</td>
      </tr>
    </tbody>
  </table> -->
</div>

<div mat-dialog-actions align="end">
  <button type="button" mat-raised-button (click)="onNoClick()">Cancel</button>

  <button type="button" mat-raised-button *ngIf="data.status == 'Pending'" (click)="genEmail(data.stockFillerId)">Gen Email</button>
  
</div>
